import { useLocation } from 'react-router-dom';

export const useQuery = (key?: string) => new URLSearchParams(useLocation().search);
